export {
  SwitchToggle,
  type SwitchToggleProps,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/SwitchToggle';
